import { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
import msalInstance from '@core/auth/msalInstance';
import getApiAccessToken from '../../utils/getApiAccessToken';
import getProductAccessToken from '../../utils/getProductAccessToken';

const ORG_HEADER = 'Organization-Authorization';

const setHeadersRequestInterceptor = async (value: InternalAxiosRequestConfig<any>) => {
  const updatedConfig: InternalAxiosRequestConfig<any> = { ...value };
  updatedConfig.headers = updatedConfig.headers ?? new AxiosHeaders();

  // Anonymous visitor (shared-study links): there is no account, so both
  // acquisitions below can only fail — and getApiAccessToken()'s
  // InteractionRequired fallback calls acquireTokenRedirect(), which would
  // navigate the anonymous page straight to B2C login. Send the request
  // unauthenticated and let the endpoint decide.
  if (!msalInstance.getActiveAccount()) {
    return updatedConfig;
  }

  // Acquired in parallel: getProductAccessToken internally awaits
  // getApiAccessToken, so these overlap rather than serialise, and
  // msal-browser dedupes identical concurrent acquireTokenSilent calls by
  // request thumbprint.
  const [accessToken, productAccessToken] = await Promise.all([
    getApiAccessToken(),
    getProductAccessToken(),
  ]);

  // Only set the headers we actually have. Setting them unconditionally used to
  // put the literal string `Bearer undefined` on the wire.
  if (accessToken) {
    updatedConfig.headers.Authorization = `Bearer ${accessToken}`;
  }

  if (productAccessToken) {
    updatedConfig.headers[ORG_HEADER] = `Bearer ${productAccessToken}`;
  }

  return updatedConfig;
};

export default setHeadersRequestInterceptor;
